import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";
import { Loader2Icon } from "lucide-react";

const SIZE_TO_PX: Record<string, number> = {
  xs: 12,
  sm: 16,
  base: 16,
  md: 20,
  lg: 24,
  "2xl": 32,
};

type SpinnerProps = Omit<ComponentProps<typeof Loader2Icon>, "size"> & {
  size?: keyof typeof SIZE_TO_PX | number | (string & {});
  spinning?: boolean;
};

function Spinner({ className, size, spinning = true, ...props }: SpinnerProps) {
  const px =
    typeof size === "number"
      ? size
      : typeof size === "string" && size in SIZE_TO_PX
        ? SIZE_TO_PX[size]
        : undefined;

  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn(px == null && "size-4", spinning && "animate-spin", className)}
      {...(px != null ? { width: px, height: px } : {})}
      {...props}
    />
  );
}

export { Spinner };
